import * as Sentry from '@sentry/react';

import { BrowserTracing } from '@sentry/tracing';

Sentry.init({
  dsn: 'https://e0ccb47639d540b8a89377f6bcf178a4:03aaa61613bf4ebda2418886f8be9db1@sentry.meitustat.com/152',
  integrations: [
    new BrowserTracing({
      tracingOrigins: [
        'localhost',
        'prepc.meitu.com',
        'betapc.meitu.com',
        'pc.meitu.com',
        'web-pcxiuxiu-beta.meitu.com',
        'web-pcxiuxiu-new-beta.meitu.com',
        'web-pcxiuxiu.meitu.com',
        /^\//,
      ],
    }),
  ],
  autoSessionTracking: false, // 由于目前自动发送session到sentry的接口会报跨域问题，暂时关闭
  enabled: process.env.REACT_APP_ENV === 'release',
  environment: process.env.REACT_APP_ENV,
  release: process.env.REACT_APP_RELEASE,
});

const uid = window.localStorage.getItem('uid');
if (uid) {
    Sentry.setUser({
        id: uid
    });
}
